import { accessProfileMessage } from './accessProfileNotice';

const EXPLICIT_CONVERSATION_ACTIONS = [
  'conversation_view',
  'conversation_page_access',
  'conversation_create',
  'conversation_reply',
  'conversation_claim',
  'conversation_transfer',
  'conversation_resolve',
  'conversation_reopen',
];

const LEGACY_CONVERSATION_SCOPES = [
  'conversation_manage',
  'conversation_unassigned_manage',
  'conversation_participating_manage',
];

export const conversationPermissionMessage = (permission, profileName) =>
  accessProfileMessage({ permission, profileName });

const currentAccount = (user, accountId) =>
  user?.accounts?.find(account => Number(account.id) === Number(accountId));

export const hasConversationPermission = (user, accountId, permission) => {
  const account = currentAccount(user, accountId);
  if (!account?.custom_role_id) return true;

  const permissions = account.permissions || [];
  if (permissions.some(item => ['administrator', 'agent'].includes(item)))
    return true;
  const hasExplicitActions =
    permissions.includes('granular_page_access') ||
    permissions.some(item => EXPLICIT_CONVERSATION_ACTIONS.includes(item));

  if (!hasExplicitActions) {
    return permissions.some(item => LEGACY_CONVERSATION_SCOPES.includes(item));
  }

  if (!permissions.includes(permission)) return false;
  if (permission === 'conversation_view') return true;
  if (!permissions.includes('conversation_view')) return false;
  if (
    !['conversation_page_access', 'conversation_view'].includes(permission) &&
    !permissions.includes('conversation_page_access')
  ) {
    return false;
  }
  return true;
};

export const hasCustomAccessProfile = (user, accountId) =>
  Boolean(currentAccount(user, accountId)?.custom_role_id);
